import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Text, Title } from "~/components/ui";

export const AppTitle: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-center">
      <Title level={4} className="m-0 p-0">
        {t("about:headertitle")}
      </Title>

      <Text tone="muted" className="hidden sm:block m-0 p-0">
        {t("about:headerSubtitle")}
      </Text>
    </div>
  );
};
